import React from "react";
import { Helmet } from "react-helmet";
import "../v3/theme.css";
import usePortfolioEffects from "../v3/usePortfolioEffects";
import Nav from "../components/v3/Nav";
import Hero from "../components/v3/Hero";
import TrustStrip from "../components/v3/TrustStrip";
import About from "../components/v3/About";
import Services from "../components/v3/Services";
import Skills from "../components/v3/Skills";
import Experience from "../components/v3/Experience";
import Work from "../components/v3/Work";
import Testimonials from "../components/v3/Testimonials";
import Cta from "../components/v3/Cta";
import ContactFooter from "../components/v3/ContactFooter";

const Home = () => {
  usePortfolioEffects();

  return (
    <>
      <Helmet>
        <title>Mohsin Idrees — Software Engineer</title>
        <meta
          name="description"
          content="Software Engineer with 5+ years across web apps, LLM chatbots, and AWS serverless. Top Rated Plus on Upwork. I build AI-powered, full-stack products that ship to production."
        />
        <meta
          name="keywords"
          content="Mohsin Idrees, Software Engineer, Full Stack Developer, AI Engineer, AI Chatbots, LangChain, AWS Serverless, Next.js, React, FastAPI"
        />
      </Helmet>

      <Nav />
      <Hero />
      <TrustStrip />
      <About />
      <Services />
      <Skills />
      <Experience />
      <Work />
      <Testimonials />
      <Cta />
      <ContactFooter />
    </>
  );
};

export default Home;
